<template>
  <div class="h-full flex flex-col" v-if="team !== null">
    <h1 class="text-4xl mb-5">{{ team.name }}</h1>
    <div id="page" @scroll="$bus.$emit('scroll')" class="content flex-grow">
      <div class="section">
        <div class="scale-grid flex max-h-50 flex-row flex-wrap">
          <tile
            :class="[mobile ? 'w-full' : 'w-1/3']"
            :key="team.headshot_image.url"
            :scale="false"
            :image="team.headshot_image.url"
            :info="false"
          />
          <div :class="[mobile ? 'w-full' : 'w-2/3', 'px-3 flex pb-6']">
            <div class="tile-content">
              <div class="fill-content mb-3">
                <p class="mb-3">{{ team.country }}</p>
                <p>{{ team.position }} @ DesignMorphine</p>
                <p class="mb-3">{{ team.title }} @ {{ team.company }}</p>
                <p>{{ team.bio }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="scale-grid flex max-h-50 flex-row flex-wrap items-start">
          <tile
            :class="[mobile ? 'w-full' : 'w-1/3']"
            v-for="(image, index) in team.work_images"
            :key="image.url"
            :image="image.url"
            @click="() => $refs.workLightbox.open(index)"
            :info="false"
          />
        </div>
      </div>
    </div>
    <ImageLightbox ref="workLightbox" :images="team.work_images" />

    <button @click="goTo(team.url, '_blank')" class="action-btn w-full bg-white-25 hover:bg-dm py-2 rounded-full">
      See More
    </button>
  </div>
</template>

<script>
import SingleImage from '@components/details/SingleImage';
import ImageSlides from '@components/details/ImageSlides';
import Icon from '@components/Icon';
import Tile from '@components/Tile';
import ImageLightbox from '@components/ImageLightbox';

export default {
  name: 'team-detail',
  components: { ImageLightbox, Tile, ImageSlides, SingleImage, Icon },
  data() {
    return {
      team: null,
      loading: true,
      mobile: this.$store.state.screenSize === 1,
    };
  },
  watch: {
    '$store.state.screenSize': function(size) {
      this.mobile = size === 1;
    },
  },
  computed: {},
  mounted() {
    this.getTeam(this.$route.params.slug)
      .then(({ data }) => {
        this.team = data;
        this.loading = false;
      })
      .catch(e => {
        if (e.response.status === 404) {
          this.$router.push('/404');
        }
      });

    this.$bus.$on('prev', () => {
      this.$router.push({
        name: `team-detail`,
        params: { slug: this.team.nav.prev },
      });
    });

    this.$bus.$on('next', () => {
      this.$router.push({
        name: `team-detail`,
        params: { slug: this.team.nav.next },
      });
    });

    this.$bus.$on('back', () => {
      this.$router.push({
        name: 'team',
      });
    });
  },

  beforeDestroy() {
    this.$bus.$off('prev');
    this.$bus.$off('next');
    this.$bus.$off('back');
  },

  methods: {
    getTeam(slug) {
      return window.axios.get(`/api/members/${slug}?include=nav`);
    },
  },
};
</script>
<style scoped lang="scss">
#router-cont {
  padding-bottom: 7.5rem !important;
}

.tile-content {
  display: flex;
  flex-direction: column;

  .fill-content {
    flex: 1 0 auto;
  }
}
</style>
